import { formatPriceWithComma } from "./assets/format";
import moment from 'moment';
import BlumarConfig from './blumar-config';

function parsingFloatValue(value) {
	return parseFloat(`${value}`.replace(',','.'));
}

export function getStorageUrl(path) {
	return `https://${BlumarConfig.blumarCdn}.blumar.com.br/${path}`
}

export function numbers(n) {
	return [...Array(n)].map((v,i) => i);
}

export function getNumber(blumarNumber) {
	return blumarNumber ? Number(blumarNumber.replace(',', '.')) : blumarNumber;
}

export function getTax(price) {
	let priceFloatValue = parsingFloatValue(price);
	return priceFloatValue * 0.10;
}

export function getDailyPriceWithoutTaxes(dailyPrice, tax) {
	let dailyPriceFloatValue = parsingFloatValue(dailyPrice);
	let taxFloatValue = parsingFloatValue(tax)
	return dailyPriceFloatValue - taxFloatValue;
}

export function formatedPrice(symbol, price){
	let valueFormated = price === ",00" || price === NaN? '00,00' : formatPriceWithComma(price);
	return symbol+" "+ valueFormated;
};

export function getFormatedDate(date){
	if(date)
		return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
	return null;
}

export async function viaCep(zipCode) {
  let res = await fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
		.then(async res => {
			let data = await res.json();
			if(data && data.erro)
				throw new Error('CEP não encontrado!');
			return data;
		})
		.catch(error => {
			console.error(error);
			alert(error.message ? error.message : "Erro ao buscar endereço via CEP!");
		});
	return res;
}



// WEBPACK FOOTER //
// ./src/util.js